import React from 'react';
import getARMToCustomLevel from '../../../../services/benchmark/getARMToCustomLevel';
import getARMToCustomLevelIcon from './BenchmarkCustomLevelIcon/getARMCustomLevelIcon';
import './BenchmarkCustomLevel.scss';
import {Tooltip, tooltipTypes} from '../../../../../Global/Tooltip';

export default function BenchmarkCustomLevel({metric, displayScore, partner}) {

  if(metric?.toLowerCase() !== 'arm') return null;

  const level = getARMToCustomLevel(displayScore, partner);
  const levelIcon = getARMToCustomLevelIcon(level, partner);

  const levelNotAvailable = level === null; // when the student doesn't have an ARM score
  const levelExceedsMax = level && level === -1; // when the student's ARM score is higher than the highest level in the mapping
  const levelIsAvailable = level && !levelNotAvailable && !levelExceedsMax;

  return (
    <div className='benchmark-custom-level'>
      {levelIsAvailable && levelIcon && <img className='arm-to-custom-level-icon' src={levelIcon} alt={`level ${level}`} />}
      {levelIsAvailable && <p className='arm-to-custom-level'>Level {level}</p>}
      {levelNotAvailable && <p className='arm-to-custom-level'>N/A</p>}
      {levelExceedsMax && <div className='exceed-mapping'>
        <p className='arm-to-custom-level'>N/A</p>
        <div className='exceed-mapping-tooltip'><Tooltip type={tooltipTypes.benchmarkARMToCustomLevelExceedsMax} /></div>
        </div>}
    </div>
  );
}